module.exports = __webpack_public_path__ + "static/jackalwere-2413b2124d5c43146e3f26b7d21f3761.jpeg";